import ko from "knockout";
import tabWrapper from "flow/wrappers/tab";
import register from "flow/knockout/register";

register.registerKnockoutBinding("tabWithDynamicIds", {
    init: function (element, valueAccessor) {
        const value = valueAccessor();

        const wrapper = tabWrapper.createWrapper(element);

        if (ko.isObservable(value)) {
            const handle = value;
            handle(wrapper);
        } else {
            wrapper.create(value);
        }
    }
});
